module.exports = __webpack_public_path__ + "18cd605999eea6380ee4428fc02f5e73.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/dirty-chart.png
// module id = 1389
// module chunks = 0